import { useRouter } from 'expo-router'
import { useCallback, useMemo } from 'react'

import { useStatusQuery } from '@/src/features/notification/services/useStatusQuery'
import { useHasIntentionNotifications } from '@/src/features/notification/ui/hooks/useHasIntentionNotifications'
import { ICON } from '@/src/general/enums/icons'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

import type { TTabBarDisplayProps, TTabNavigationData } from '../Tab.types'

export const useTabNavigationData = (): TTabNavigationData => {
  const { navigate } = useRouter()
  const { routes } = useRoutes()
  const onNavigate: TTabBarDisplayProps['onNavigate'] = useCallback(
    (_, route) => {
      const routeNav = routes[route.name]
      if (typeof routeNav === 'function') {
        navigate(routeNav())
      }
    },
    [navigate, routes],
  )

  const { t } = useTranslate()
  const hasIntentionNotifications = useHasIntentionNotifications()
  const { data: status } = useStatusQuery()
  const navigationData: TTabNavigationData = useMemo(
    () => ({
      'prayer-space': {
        icon: ICON.PRAYER_SPACE,
        text: t('tab.prayer-space') /*'Coin prière'*/,
        hasNotifications: false,
        onNavigate,
      },
      communities: { icon: ICON.SEARCH, text: t('tab.discover') /*'Rechercher'*/, hasNotifications: false, onNavigate },
      intentions: {
        icon: ICON.INTENTION,
        text: t('word.intentions') /*'Intentions'*/,
        hasNotifications: hasIntentionNotifications,
        onNavigate,
      },
      messages: {
        icon: ICON.MESSAGING,
        text: t('tab.messaging'),
        hasNotifications: (status?.unreadConversations || 0) > 0,
        notificationsCount: status?.unreadConversations || 0,
        onNavigate,
      },
    }),
    [onNavigate, hasIntentionNotifications, status, t],
  )

  return navigationData
}
